export let internalLogger;
export let api;
export function setDependencies(newInternalLogger, newApi) {
    internalLogger = newInternalLogger;
    api = newApi;
}
//# sourceMappingURL=dependencies.js.map